 


import React, { useState } from "react";
import luxuryRoomImage from "../img/banner/interior-design-7132458_1280.jpg";
import banquetHallImage from "../img/banner/bedroom-3475656_1280.jpg";
import acRoomImage from "../img/banner/bedroom-7132434_1280.jpg";
import deluxeRoomImage from "../img/banner/bedroom-5772286_1280.jpg";
import  conferenceRoomImage from "../img/banner/bed-1839183_1280.jpg";
import suiteRoomImage from "../img/banner/real-estate-7132396_1280.jpg";

const vehicles = [
  { 
    name: "Luxury Rooms", 
    image: luxuryRoomImage, 
    features: ["AC", "King Size Bed", "Private Balcony", "Smart TV", "Mini Fridge", "Room Service"] 
  },
  { 
    name: "AC Rooms", 
    image: banquetHallImage, 
    features: ["AC", "King Size Bed", "Private Balcony", "Smart TV", "Mini Fridge", "Room Service"] 
  },
  { 
    name: "Deluxe Rooms", 
    image: deluxeRoomImage, 
    features: ["AC", "Queen Size Bed", "Window View", "Dining Table", "Smart TV", "Free WiFi"] 
  },
  { 
    name: "Standard AC Rooms", 
    image: acRoomImage, 
    features: ["AC", "Double Bed", "Window View", "Work Desk", "Wardrobe", "Attached Bathroom"] 
  },
  { 
    name: "Standard Luxury Rooms", 
    image: conferenceRoomImage, 
    features: ["AC", "King Size Bed", "Private Balcony", "Smart TV", "Mini Fridge", "Room Service"] 
  },
  { 
    name: "Suite Room", 
    image: suiteRoomImage, 
    features: ["Luxury Interiors", "AC", "Living Area", "King Size Bed", "Private Jacuzzi", "Personal Butler"] 
  },
];


const CarFilter = () => {
  const [hoveredVehicle, setHoveredVehicle] = useState(null);

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px", fontFamily: "Arial, sans-serif" }}>
      
      {/* Main Container for Vehicles and Form */}
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "30px",
        maxWidth: "1200px",
        width: "100%"
      }}>
        
        {/* Vehicles Grid */}
        <div
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(268px, 1fr))",
    gap: "20px",
    flex: "1",
    minWidth: "300px",
  }}
>
  {vehicles.map((vehicle, index) => (
    <div
      key={index}
      style={{
        position: "relative",
        textAlign: "center",
        overflow: "hidden",
        borderRadius: "10px",
        cursor: "pointer",
      }}
      onMouseEnter={() => setHoveredVehicle(vehicle)}
      onMouseLeave={() => setHoveredVehicle(null)}
    >
      {/* Vehicle Image */}
      <img
  src={vehicle.image}
  alt={vehicle.name}
  style={{
    width: "100%",
    height: "auto",
    borderRadius: "10px",
  }}
/>


      {/* Hover Overlay */}
      <div
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          color: "#fff",
          textAlign: "center",
          padding: "20px",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          opacity: hoveredVehicle === vehicle ? 1 : 0,
          visibility: hoveredVehicle === vehicle ? "visible" : "hidden",
          transition: "opacity 0.4s ease-in-out, visibility 0.4s ease-in-out",
        }}
      >
        <h4>{vehicle.name}</h4>
        <ul
  style={{
    display: "flex",
    flexWrap: "wrap",
    listStyle: "none",
    padding: 0,
    margin: 0,
    gap: "10px",
  }}
>
  {vehicle.features.map((feature, i) => (
    <li
      key={i}
      style={{
        flex: "1 1 calc(50% - 10px)", // Two equal columns on large screens
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        textAlign: "center",
        backgroundColor: "gray", // Red background
        color: "white", // White text for contrast
        fontWeight: "bold",
      }}
    >
      {feature}
    </li>
  ))}
</ul>

<style>
  {`
    @media (max-width: 425px) {
      ul li {
        flex: 1 1 100%; /* Full width for screens up to 425px */
      }
    }

    @media (max-width: 375px) {
      ul li {
        flex: 1 1 100%; /* Full width for screens up to 375px */
        padding: 8px; /* Reduce padding */
        font-size: 14px; /* Adjust font size */
      }
    }
    
    @media (max-width: 320px) {
      ul li {
        flex: 1 1 100%; /* Full width for very small screens (320px) */
        padding: 6px; /* Further reduce padding */
        font-size: 12px; /* Reduce font size for smaller screens */
      }
    }
  `}
</style>




        
      </div>
      
    </div>
  
   
  ))}
{/* 
<div style={{ textAlign: "center", marginTop: "10px" }}>
  <button
    style={{
      padding: "10px 15px",
      backgroundColor: "red",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      fontSize: "16px",
      width: "100%", 
      maxWidth: "200px", 
      display: "block", 
    }}
    onClick={() => window.location.href = `/room-details/${vehicles.name.toLowerCase().replace(/\s+/g, '-')}`}
  >
    Read More
  </button>
</div> */}

</div>


        {/* Enquiry Form */}
        <div className="from-enquery">
  <h3 style={{fontFamily:'roboto',fontWeight:'400'}}>Hotel Booking </h3>
  <form>
    <input type="text" placeholder="Your Name" required />
    <input type="tel" placeholder="Your Phone" required />
    
    <label style={{textAlign:'left'}}>Check-in Date:</label>
    <input type="date" required />
    
    <label style={{textAlign:'left'}}>Check-out Date:</label>
    <input type="date" required />
    
   
    <input type="number" min="1" placeholder="Number of Adults" required />
    
   
    <input type="number" min="0" placeholder="Number of Children" />
    
   
    <input type="number" min="1" placeholder="Number of Rooms" required />
    
    <textarea placeholder="Special Requests (Optional)"></textarea>
    
    <button type="submit">Submit Booking Enquiry</button>
  </form>
</div>

<style>
  {`
    .from-enquery {
      width: 350px;
      padding: 20px;
      background-color: #f9f9f9;
      border-radius: 8px;
      box-shadow: 0px 0px 10px rgba(0,0,0,0.1);
      flex-shrink: 0;
      min-width: 300px;
      text-align: center;
    }

    .from-enquery h3 {
      color: #ffca00;
    }

    .from-enquery form {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .from-enquery input, .from-enquery textarea {
      padding: 8px;
      border-radius: 4px;
      border: 1px solid #ccc;
      width: 100%;
    }

    .from-enquery button {
      padding: 10px;
      background-color: #ffcc00;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-weight: bold;
    }

    /* Media Queries */
    @media (max-width: 600px) {
      .from-enquery {
        width: 300px;
      }
    }

    @media (max-width: 425px) {
      .from-enquery {
        width: 284px;
      }
    }

    @media (max-width: 375px) {
      .from-enquery {
        width: 284px;
      }
    }

    @media (max-width: 320px) {
      .from-enquery {
        width: 284px;
        padding: 15px;
      }
    }
  `}
</style>


      </div>

    </div>
  );
};

export default CarFilter;

